import React from 'react'
import {Icon} from '@chakra-ui/react'

const ListIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 6V4H24V6H10ZM10 12V14H24V12H10ZM10 20V22H24V20H10ZM0 20V22H7V20H0ZM0 14V12H7V14H0ZM0 4V6H7V4H0Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default ListIcon
